import {
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { Order } from "src/app/core/entities/order";
import { OrderItem } from "src/app/core/entities/orderItem";
import { ObserverPedido, PedidoService } from "src/app/core/services/pedido-service";
import {
  PRELOADED_PRODUCT_NAV_STATE,
  ProductService,
} from "src/app/core/services/product-service";
import { CorteService } from "src/app/modules/product/services/corte.service";
@Component({
  selector: "app-catalog-cart",
  templateUrl: "./catalog-cart.component.html",
  styleUrls: ["./catalog-cart.component.css"],
})
export class CatalogCartComponent implements OnInit, OnDestroy, ObserverPedido {
  @Output() showCart = new EventEmitter<void>();
  @Output() hideCart = new EventEmitter<void>();
  @Output() itemEmitted = new EventEmitter<OrderItem>();
  titleBackgroundColor: string;
  items: OrderItem[] = [];
  orderItems: OrderItem[] = [];
  imageApi: string;
  imageApiProdutos: string;
  total = 0;
  SITE;

  constructor(
    private pedidoService: PedidoService,
    private router: Router,
    private productService: ProductService,
    private corteService: CorteService
  ) {
    this.titleBackgroundColor =
      Configuracoes.SITE.backgroundColorSliderSuperior;
  }

  notify(pedido: Order) {
    this.orderItems = pedido.itens;
    this.refresh();
  }

  ngOnInit() {
    this.SITE = Configuracoes.SITE;
    this.imageApi = Configuracoes.API_IMAGENS;
    this.imageApiProdutos = Configuracoes.API_IMAGENS_PRODUTOS;
    this.orderItems = this.pedidoService.pedido.itens;
    this.refresh();
    this.pedidoService.registerObserver(this);
  }

  ngOnDestroy(): void {
    this.pedidoService.removeObserver(this);
  }

  removeItem(item: OrderItem) {
    // emite o item para o componente pai
    
    this.pedidoService.removeCartItem(
      item.produto,
      (order: Order) => {
        this.pedidoService.select(order);
        this.pedidoService.removed();
        this.itemEmitted.emit(item);
        this.productService.setItemRemoved(item.produto)
        if (!this.items.length) this.hideCart.emit();
      },
      item.pedidocliente_id
    );
  }
  

  refresh() {
    this.items = [];
    let productsMap = new Map();

    [...this.orderItems]
      .sort((a, b) => {
        const aid = a.id != null ? Number(a.id) : 0;
        const bid = b.id != null ? Number(b.id) : 0;
        if (aid < bid) {
          return 1;
        }
        if (aid > bid) {
          return -1;
        }
        return 0;
      })
      .forEach((item) => {
        if (!productsMap.get(item.produto)) {
          productsMap.set(item.produto, { ...item });
        } else {
          productsMap.get(item.produto).quantidade += item.quantidade;
          productsMap.get(item.produto).total += item.total;
        }
      });

    productsMap.forEach((item) => {
      if (item.quantidade > 0) this.items.push(item);
    });

    const pedido = this.pedidoService.pedido;
    const apiTotal =
      pedido?.valor_total_pedido ?? pedido?.total_itensresumo?.valor_total_pedido;
    if (apiTotal != null && Number.isFinite(Number(apiTotal))) {
      this.total = Number(apiTotal);
    } else {
      this.total = this.items
        .map((item) => item.total)
        .reduce((previous, current) => previous + current, 0);
    }
  }

  abrirItem(item: OrderItem): void {
    const produtoId = (item as any)?.produto;
    if (!produtoId) {
      return;
    }

    this.productService.findById(
      produtoId,
      (p: any) => {
        const vaiParaCorte = this.corteService.deveUsarPaginaCorte(p, false);
        const url = vaiParaCorte
          ? `/produto-corte/${produtoId}`
          : `/produto/${produtoId}`;
        this.navigateToProduto(url, vaiParaCorte, p);
      },
      () => {
        const vaiParaCorte = this.corteService.deveUsarPaginaCorte(
          item as any,
          false
        );
        const url = vaiParaCorte
          ? `/produto-corte/${produtoId}`
          : `/produto/${produtoId}`;
        this.navigateToProduto(url, vaiParaCorte);
      }
    );
  }

  private navigateToProduto(
    url: string,
    isCorte?: boolean,
    preloadedProduct?: any
  ): void {
    this.hideCart.emit();
    this.productService.stashCurrentCatalogUiForReturn();

    const match = url.match(/^\/([^/]+)\/(.+)$/);
    if (match) {
      const [, route, id] = match;
      const queryParams = isCorte ? { corte: "1" } : undefined;
      this.router.navigate(["/", route, id], {
        queryParams,
        replaceUrl: false,
        state: preloadedProduct
          ? { [PRELOADED_PRODUCT_NAV_STATE]: preloadedProduct }
          : undefined,
      });
      return;
    }

    this.router.navigateByUrl(url, {
      state: preloadedProduct
        ? { [PRELOADED_PRODUCT_NAV_STATE]: preloadedProduct }
        : undefined,
    });
  }
}
